import { render, staticRenderFns } from "./1023.vue?vue&type=template&id=9b654094&scoped=true&"
import script from "./1023.vue?vue&type=script&lang=js&"
export * from "./1023.vue?vue&type=script&lang=js&"
import style0 from "./1023.vue?vue&type=style&index=0&id=9b654094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b654094",
  null
  
)

export default component.exports